var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Confirmation",
    transform: "translate(-130.000000, -124.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(130.000000, 124.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E9E5FC",
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    rx: 28
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7834381,25.0352597 L25.0352597,99.7834381 C11.5786195,98.4006436 0.946553624,87.4880995 -1.31283873e-14,73.9067439 L73.9067439,9.99200722e-14 C87.4880995,0.946553624 98.4006436,11.5786195 99.7834381,25.0352597 Z",
    id: "Combined-Shape",
    fill: "#E1D9FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6858182,46.2974545 C72.8734545,47.5061818 73,48.7367273 73,50 C73,63.2545455 62.2545455,74 49,74 C35.7454545,74 25,63.2545455 25,50 C25,36.7454545 35.7454545,26 49,26 C54.1207273,26 58.8574545,27.6167273 62.7541818,30.3483636 L59.6516364,33.5272727 C56.5796364,31.5352727 52.9272727,30.3636364 49,30.3636364 C38.1738182,30.3636364 29.3636364,39.1738182 29.3636364,50 C29.3636364,60.8261818 38.1738182,69.6363636 49,69.6363636 C59.6778182,69.6363636 68.3723636,61.0661818 68.6145455,50.4472727 L72.6858182,46.2974545 Z M70.6087273,28.5461818 L50.0909091,49.5767273 L41.7061818,41.6916364 L34.9534545,48.4509091 L50.0909091,63.0909091 L77.3636364,35.3010909 L70.6087273,28.5461818 Z",
    id: "Shape",
    fill: "#524686",
    fillRule: "nonzero"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.e1718ac99ceee05bb1625ff18e127c90.svg";
export { ForwardRef as ReactComponent };